console.log('✅ listing-page-component.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, setAppStateValueByKey } from '../../js/state.js';
import { getTextTranslationByKey, loadTextTranslations } from '../../js/translator.js';
import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentBreadcrumb } from '../bread-crumbs/bread-crumb.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import {
  convertStringAmountToCurrencyAndSignDirectionForLanguage,
  getCurrencyCultureSymbolOnLeftOrRight,
} from '../../js/utils-convert-currency.js';
import {
  convertNumberStringFromUKFormatToAnyLanguageFormatDouble,
  convertStringToDecimal,
  convertStringToInt,
} from '../../js/utils-convert-numbers.js';
import { buildComponentCatalogListingImageSlider } from '../catalog/catalog-listing-image-slider.js';

import { navigateTo } from '../../js/router-navigator.js';

import { LRUCacheWithTTL } from '../../js/utils-cache.js';

import { initLinksTranslator } from '../../js/router-routes-manager.js';

let isOpenListingLeadTimes = true;
let isOpenListingDiscounts = true;
let isOpenListingCustomisations = true;

export async function buildComponentCatalogListing(params, listingModeIsLive) {
  console.log(`🔄 Building Component: CatalogSubcategories - lang: ${appState.SiteLanguageCookie}`);

  listingModeIsLive = true;

  try {
    const pageSkeletonHTML = await buildPageSkeleton();

    const actualbuildListingContentHTML = await buildActualListingContent(
      params,
      listingModeIsLive
    );

    //const html = pageSkeleton;
    const html = actualbuildListingContentHTML;

    console.log('✅ ComponentCatalogListing built successfully.');

    // Register event listeners
    // registerEventListenerToAttach(attachEventListenersCatalogProducts);
    registerEventListenerToAttach(async () => attachMainEventListenersForThisComponent());

    return html;
  } catch (err) {
    console.error('❌ Error building ComponentCatalogListing:', err);
    return '<div>Error loading ComponentCatalogListing </div>';
  }
}

/**
 * Attach event listeners to the CatalogCategories component
 */
async function attachMainEventListenersForThisComponent() {
  try {
    console.log('✅ ComponentCatalogListing event listeners attached.');
    // Placeholder for future event listeners if needed

    //  alert("attachMainEventListenersForThisComponent called");

    await setupApplyToogleButtonListeners();

    await setupBuyNowButtonListeners();

    await setupContactSellerButtonListeners();

    await setupMainAddToCartButtonListeners();

    await setupOrderQtnTextBoxAndButtonsListeners();
  } catch (error) {
    console.error('❌ Error attaching event listeners to ComponentCatalogListing:', error);
  }
}

export async function setupApplyToogleButtonListeners() {
  const btnToogleLeadTimes = document.getElementById('divLeadTimesHeader');
  const btnToogleDiscounts = document.getElementById('divDiscountsHeader');
  const btnToogleCustomisations = document.getElementById('divCustomisationsHeader');

  if (btnToogleLeadTimes) {
    const onLeadTimesClick = async () => handleToogleListingLeadTimesSection();
    btnToogleLeadTimes.removeEventListener('click', onLeadTimesClick);
    btnToogleLeadTimes.addEventListener('click', onLeadTimesClick);
  }

  if (btnToogleDiscounts) {
    const onDiscountsClick = async () => handleToogleListingDiscountsSection();
    btnToogleDiscounts.removeEventListener('click', onDiscountsClick);
    btnToogleDiscounts.addEventListener('click', onDiscountsClick);
  }

  if (btnToogleCustomisations) {
    const onCustomisationsClick = async () => handleToogleListingCustomisationsSection();
    btnToogleCustomisations.removeEventListener('click', onCustomisationsClick);
    btnToogleCustomisations.addEventListener('click', onCustomisationsClick);
  }

  // Set states to true at start
  isOpenListingLeadTimes = true;
  isOpenListingDiscounts = true;
  isOpenListingCustomisations = true;
}

//async function setupApplyToogleButtonListeners() {

//   // alert("setupApplyToogleButtonListeners called");

//    const btnToogleLeadTimes = document.getElementById("divLeadTimesHeader");
//    const btnToogleDiscounts = document.getElementById("divDiscountsHeader");
//    const btnToogleCustomisations = document.getElementById("divCustomisationsHeader");

//    if (btnToogleLeadTimes) {

//        // replace with clone to remove old handlers
//        const clone = btnToogleLeadTimes.cloneNode(true);
//        btnToogleLeadTimes.parentNode.replaceChild(clone, btnToogleLeadTimes);

//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//            handleToogleListingLeadTimesSection();

//        }
//        );

//    }

//    if (btnToogleDiscounts) {
//        // replace with clone to remove old handlers
//        const clone = btnToogleDiscounts.cloneNode(true);
//        btnToogleDiscounts.parentNode.replaceChild(clone, btnToogleDiscounts);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            handleToogleListingDiscountsSection();
//        }
//        );

//    }

//    if (btnToogleCustomisations) {
//        // replace with clone to remove old handlers
//        const clone = btnToogleCustomisations.cloneNode(true);
//        btnToogleCustomisations.parentNode.replaceChild(clone, btnToogleCustomisations);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            handleToogleListingCustomisationsSection();
//        }
//        );
//    }

//    //set them to true at start
//    isOpenListingLeadTimes = true;
//    isOpenListingDiscounts = true;
//    isOpenListingCustomisations = true;

//}

async function handleToogleListingLeadTimesSection() {
  const dropdown = document.getElementById('divLeadTimesContent');
  if (dropdown) {
    isOpenListingLeadTimes = !isOpenListingLeadTimes;
    dropdown.style.display = isOpenListingLeadTimes ? 'block' : 'none';
  }

  const icon = document.getElementById('imgToggleLeadTimes');
  if (icon) {
    icon.classList.toggle('cartTopNewButton-Image-toggle-icon-rotated', isOpenListingLeadTimes);
  }
}

async function handleToogleListingDiscountsSection() {
  const dropdown = document.getElementById('divDiscountsContent');
  if (dropdown) {
    isOpenListingDiscounts = !isOpenListingDiscounts;
    dropdown.style.display = isOpenListingDiscounts ? 'block' : 'none';
  }

  const icon = document.getElementById('imgToggleDiscounts');
  if (icon) {
    icon.classList.toggle('cartTopNewButton-Image-toggle-icon-rotated', isOpenListingDiscounts);
  }
}

async function handleToogleListingCustomisationsSection() {
  const dropdown = document.getElementById('divCustomisationsContent');
  if (dropdown) {
    isOpenListingCustomisations = !isOpenListingCustomisations;
    dropdown.style.display = isOpenListingCustomisations ? 'block' : 'none';
  }

  const icon = document.getElementById('imgToggleCustomisations');
  if (icon) {
    icon.classList.toggle(
      'cartTopNewButton-Image-toggle-icon-rotated',
      isOpenListingCustomisations
    );
  }
}

async function setupBuyNowButtonListeners() {
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  const { _tempLinksTranslator } = await loadMyTranslationsService(appState.SiteLanguageCookie);
  const { keyShoppingCart: linkShoppingCart } = _tempLinksTranslator;

  const btn = document.getElementById('buyNowbtn');
  if (!btn) return;

  const onBuyNowClick = async () => {
    handleAddItemToCart();
    navigateTo(linkShoppingCart);
  };

  // Safely remove any existing instance before re-attaching
  btn.removeEventListener('click', onBuyNowClick);
  btn.addEventListener('click', onBuyNowClick);
}

//async function setupBuyNowButtonListeners() {

//    // Dynamically import the shared helper,
//    // so it ends up in its own "translation-service" chunk:
//    const { loadMyTranslationsService } = await import(
//        /* webpackChunkName: "translation-service" */
//        /* webpackPrefetch: true */
//        "../../services/my-translator-service.js"
//    );

//    // 1) Load translations in parallel (cached after first call)
//    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(appState.SiteLanguageCookie);

//    const {

//        keyShoppingCart: linkShoppingCart,

//    } = _tempLinksTranslator;

//    const btn = document.getElementById("buyNowbtn");

//    if (btn) {

//        // replace with clone to remove old handlers
//        const clone = btn.cloneNode(true);
//        btn.parentNode.replaceChild(clone, btn);

//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//            handleAddItemToCart();

//            navigateTo(linkShoppingCart)

//        }
//        );

//    }

//}

async function setupContactSellerButtonListeners() {
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  const { _tempLinksTranslator } = await loadMyTranslationsService(appState.SiteLanguageCookie);
  const { keyMyChats: linkMyChats } = _tempLinksTranslator;

  const btn = document.getElementById('btnContactSeller');
  if (!btn) return;

  const onContactSellerClick = async () => {
    navigateTo(linkMyChats);
  };

  // Safely remove any previously attached listener
  btn.removeEventListener('click', onContactSellerClick);
  btn.addEventListener('click', onContactSellerClick);
}

//async function setupContactSellerButtonListeners() {

//    // Dynamically import the shared helper,
//    // so it ends up in its own "translation-service" chunk:
//    const { loadMyTranslationsService } = await import(
//        /* webpackChunkName: "translation-service" */
//        /* webpackPrefetch: true */
//        "../../services/my-translator-service.js"
//    );

//    // 1) Load translations in parallel (cached after first call)
//    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(appState.SiteLanguageCookie);

//    const {

//        keyMyChats: linkMyChats,

//    } = _tempLinksTranslator;

//    const btn = document.getElementById("btnContactSeller");
//    if (btn) {
//        // replace with clone to remove old handlers
//        const clone = btn.cloneNode(true);
//        btn.parentNode.replaceChild(clone, btn);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//            navigateTo(linkMyChats)
//        }
//        );
//    }
//}

async function handleContactSeller() {
  alert('handleContactSeller called');
  // Implement the logic to handle contact seller action
  // This could involve opening a chat window, redirecting to a contact form, etc.
  // For example:
}

async function handleMainBtnAddItemToCart() {
  //alert("handleAddItemToCart called");

  const {
    keyAddToCart: lblAddToCart,
    KeyAdding: lblAdding,
    keyAdded: lblAdded,
  } = _tempTextTranslator;

  const btn = document.getElementById('addToCartButton');

  if (btn) {
    //change the text to Adding
    btn.innerText = lblAdding;

    // add the loading class
    btn.classList.add('myloadingbuybtn');

    await handleAddItemToCart();

    // after 2 seconds change the text to Added
    setTimeout(() => {
      btn.innerText = lblAdded;
      btn.classList.remove('myloadingbuybtn');
    }, 2000);

    // after 2 seconds change the text to Add to Cart
    setTimeout(() => {
      btn.innerText = lblAddToCart;
    }, 4000);
  }
}

async function handleAddItemToCart() {
  //alert("handleAddItemToCart called");
  //_myUserIdentityInformationService.MyUserLastPageVisitedListing = _navigationManager.Uri;

  const currenURL = window.location.href;

  setAppStateValueByKey('MyUserLastPageVisitedListing', currenURL);

  // alert(currenURL);

  //        MyBoolOnlyModel result = await _shoppingCartDataService.ShoppingCartAddOrUpdateItemWithQtyAsync(finalSelectedSKU, tempQty, _myUserIdentityInformationService.MyUserID, _myUserIdentityInformationService.MyBuyingEntityID, _myUserIdentityInformationService.MyBuyingEntityType, selectedDepartmentID.ToString(), selectedCategoryID.ToString(), selectedProductID.ToString(), "0", _myUserIdentityInformationService.SiteLanguageCookie, _currentComponentCancellationTokenSource.Token);
}

export async function setupMainAddToCartButtonListeners() {
  const btn = document.getElementById('addToCartButton');
  if (!btn) return;

  const onMainAddToCartClick = async () => {
    handleMainBtnAddItemToCart();
  };

  // Safely remove any previously attached instance
  btn.removeEventListener('click', onMainAddToCartClick);

  // Attach fresh listener
  btn.addEventListener('click', onMainAddToCartClick);
}

//async function setupMainAddToCartButtonListeners() {
//    const btn = document.getElementById("addToCartButton");
//    if (btn) {

//        // replace with clone to remove old handlers
//        const clone = btn.cloneNode(true);
//        btn.parentNode.replaceChild(clone, btn);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//            handleMainBtnAddItemToCart();
//        }
//        );
//    }
//}

async function setupOrderQtnTextBoxAndButtonsListeners() {
  const btnPlus = document.getElementById('btnIncreaseQty');
  if (btnPlus) {
    const onIncreaseClick = async () => IncreaseOrderQty();
    btnPlus.removeEventListener('click', onIncreaseClick);
    btnPlus.addEventListener('click', onIncreaseClick);
  }

  const btnMinus = document.getElementById('btnDecreaseQty');
  if (btnMinus) {
    const onDecreaseClick = async () => ReduceOrderQty();
    btnMinus.removeEventListener('click', onDecreaseClick);
    btnMinus.addEventListener('click', onDecreaseClick);
  }

  const txtBox = document.getElementById('txtAddToCartQyt');
  if (txtBox) {
    const onBlurValidateQty = async () => ValidateOrderQty();
    txtBox.removeEventListener('blur', onBlurValidateQty);
    txtBox.addEventListener('blur', onBlurValidateQty);
  }
}

//async function setupOrderQtnTextBoxAndButtonsListeners() {

//    const btnPlus = document.getElementById("btnIncreaseQty");

//    if (btnPlus) {

//        // replace with clone to remove old handlers
//        const clone = btnPlus.cloneNode(true);
//        btnPlus.parentNode.replaceChild(clone, btnPlus);

//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            IncreaseOrderQty();
//        });
//    }

//    const btnMinus = document.getElementById("btnDecreaseQty");
//    if (btnMinus) {
//        // replace with clone to remove old handlers
//        const clone = btnMinus.cloneNode(true);
//        btnMinus.parentNode.replaceChild(clone, btnMinus);

//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            ReduceOrderQty();
//        });
//    }

//    const txtBox = document.getElementById("txtAddToCartQyt");

//    if (txtBox) {
//        // replace with clone to remove old handlers
//        const clone = txtBox.cloneNode(true);
//        txtBox.parentNode.replaceChild(clone, txtBox);

//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "blur", async () => {
//            ValidateOrderQty();

//        });

//    }

//}

function IncreaseOrderQty() {
  //  return;
  let txtOrderQty = document.getElementById('txtAddToCartQyt');

  var myQTY = 1;

  if (txtOrderQty) {
    var myQTY = txtOrderQty.value.replace(/\D/g, '').replace(/ /g, '');
  }

  // myQTY = "911";
  var isValidInt = isNumeric(myQTY);

  if (isValidInt == true) {
    if (txtOrderQty) {
      txtOrderQty.value = parseInt(myQTY) + 1;
    }

    ValidateOrderQty();
  } else {
    ValidateOrderQty();
  }
}

function RefreshResetOrderQuantity() {
  let txtMOQQty = document.getElementById('lblMOQQty');
  let txtOrderQty = document.getElementById('txtAddToCartQyt');

  if (txtOrderQty) {
    if (txtMOQQty) {
      txtOrderQty.value = txtMOQQty.innerText;
    }
  }

  ValidateOrderQty();
}

function ReduceOrderQty() {
  // return;
  let txtOrderQty = document.getElementById('txtAddToCartQyt');

  var myQTY = 1;

  if (txtOrderQty) {
    myQTY = txtOrderQty.value.replace(/\D/g, '').replace(/ /g, '');
  }

  var isValidInt = isNumeric(myQTY);

  if (isValidInt == true) {
    if (txtOrderQty) {
      txtOrderQty.value = parseInt(myQTY) - 1;
    }
    ValidateOrderQty();
  } else {
    ValidateOrderQty();
  }
}

function ValidateOrderQty() {
  // return;
  let txtMOQQty = document.getElementById('lblMOQQty');
  let txtOrderQty = document.getElementById('txtAddToCartQyt');
  let btnDecreaseQtyX = document.getElementById('btnDecreaseQty');

  let moqX = 1;

  if (txtMOQQty) {
    moqX = parseInt(txtMOQQty.innerText);
  }

  let qtyX = 1;

  if (txtOrderQty) {
    qtyX = parseInt(txtOrderQty.value);
  }

  if (!moqX) {
    moqX = 1;
  }
  if (!qtyX) {
    qtyX = 1;
  }

  if (moqX >= qtyX) {
    if (txtOrderQty) {
      txtOrderQty.value = moqX;
    }
    if (btnDecreaseQtyX) {
      btnDecreaseQtyX.disabled = true;
    }

    //  alert("trigger 1");
  } else {
    if (txtOrderQty) {
      txtOrderQty.value = qtyX;
    }

    if (btnDecreaseQtyX) {
      btnDecreaseQtyX.disabled = false;
    }
  }
  //  else {
  //     alert("trigger 2");
  // }

  //   alert("moqT " + txtMOQQty.innerText + " -- moqX " + moqX + " -- qtyX " + qtyX);
}

function isNumeric(str) {
  let numberX = parseInt(str);

  if (!numberX) {
    return false;
  } else {
    return true;
  }
}

export async function buildActualListingContent(params, listingModeIsLive) {
  // Dynamically import the shared helper,
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  //await initTempTextTranslator(appState.SiteLanguageCookie);
  //await initTempLinksTranslator(appState.SiteLanguageCookie);

  const {
    keyHome: lblHome,
    keyMinimumOrder: lblMinimumOrder,
    keyDiscounts: lblDiscounts,
    keyCustomisable: lblCustomisable,
    keyCustomLogo: lblCustomLogo,
    keyCustomPackaging: lblCustomPackaging,
    keyProductRedesign: lblProductRedesign,
    keyFeatures: lblFeatures,
    keySpec: lblSpec,
    keyReviews: lblReviews,
    keyFAQs: lblFAQs,
    keyShippedFromCountry: lblShippedFromCountry,
    keyCountryOfOrigin: lblCountryOfOrigin,
    keyCountryOfSeller: lblCountryOfSeller,
    keySoldBy: lblSoldBy,
    keyWriteAReview: lblWriteAReview,
    keyQuestion: lblQuestion,
    keyAnswer: lblAnswer,
    keyAskAQuestion: lblAskAQuestion,
    keyAddToCart: lblAddToCart,
    keyEstimatedDelivery: lblEstimatedDelivery,
    keyLeadTime: lblLeadTime,
    keySameDay: lblSameDay,
    keyDays: lblDays,
    keyDay: lblDay,
    keyTBC: lblTBC,
    keyContactSeller: lblContactSeller,
    keyBuyNow: lblBuyNow,
    keyWantItDeliveredFast: lblWantItDeliveredFast,
    keyChooseExpressDeliveryAtCheckout: lblChooseExpressDeliveryAtCheckout,
    keyPayment: lblPayment,
    keyPayPayAccepted: lblPayPayAccepted,
    keyCardsAccepted: lblCardsAccepted,
  } = _tempTextTranslator;

  const {
    keyStore: linkStore,
    keyDashboard: linkDashboard,
    keyShoppingCart: linkShoppingCart,
    keyMyChats: linkMyChats,
  } = _tempLinksTranslator;

  let departmentID = '';
  let departmentSEOPageName = '';
  let categoryID = '';
  let categorySEOPageName = '';
  let productID = '';
  let productSEOPageName = '';
  let listingID = '';
  let skuID = '';

  let departmentLinkForProduct = '';
  let categoryLinkForProduct = '';
  let productLinkForProduct = '';

  let departmentNameForProduct = '';
  let categoryNameForProduct = '';
  let productNameForProduct = '';

  // params like params 17,clothes-shoes,1,womens-clothing,127,dresses,26,147,navy-midi-sweatshirt-dress-xl

  //get the values from the params
  const valuesNeeded = params.split(',');
  departmentID = valuesNeeded[0];
  departmentSEOPageName = valuesNeeded[1];
  categoryID = valuesNeeded[2];
  categorySEOPageName = valuesNeeded[3];
  productID = valuesNeeded[4];
  productSEOPageName = valuesNeeded[5];
  listingID = valuesNeeded[6];
  skuID = valuesNeeded[7];

  let specificProductDetails = {};

  // Fetch the specific product details
  specificProductDetails = await fetchProductDetailsWithCategoryDetailsAndDepartmentDetailsByID(
    productID,
    categoryID,
    departmentID
  );

  departmentLinkForProduct = `/${appState.SiteLanguageCookie}/${specificProductDetails.currentDepartmentID}/${specificProductDetails.currentDepartmentSEOPageName}`;

  categoryLinkForProduct = `/${appState.SiteLanguageCookie}/${specificProductDetails.currentDepartmentID}/${specificProductDetails.currentDepartmentSEOPageName}/${specificProductDetails.currentCategoryID}/${specificProductDetails.currentCategorySEOPageName}`;

  productLinkForProduct = `/${appState.SiteLanguageCookie}/${specificProductDetails.currentDepartmentID}/${specificProductDetails.currentDepartmentSEOPageName}/${specificProductDetails.currentCategoryID}/${specificProductDetails.currentCategorySEOPageName}/${specificProductDetails.productID}/${specificProductDetails.seoPageName}`;

  departmentNameForProduct = specificProductDetails.currentDepartmentName;
  categoryNameForProduct = specificProductDetails.currentCategoryName;
  productNameForProduct = specificProductDetails.name;

  const text1 = lblHome;
  const link1 = '/';
  const text2 = departmentNameForProduct;
  const link2 = departmentLinkForProduct;
  const text3 = categoryNameForProduct;
  const link3 = categoryLinkForProduct;
  const text4 = productNameForProduct;
  const link4 = productLinkForProduct;
  const text5 = '';
  const link5 = '';

  const listingDetails = await populateSelectedListing(listingID);
  let selectedSKU = [];

  // alert(`skus : ${JSON.stringify(listingDetails.skUs)}`);

  if (!listingDetails.skUs) {
    console.warn(`⚠️ No selected SKU found with ID '${skuID}' in listing`);
  } else {
    selectedSKU = listingDetails.skUs.find(s => s.skuid === skuID);
  }

  //if selectedSKU select the first one
  if (!selectedSKU) {
    selectedSKU = listingDetails.skUs[0];
  }
  //console.log("selectedSKU", selectedSKU);

  //if selectedSKU is null or undefined retunrn empty []
  if (!selectedSKU) {
    console.warn(`⚠️ No selected SKU found with ID '${skuID}' in listing`);
    selectedSKU = [];
  }

  let possibleDifferentSellerDetails = await populateBestGuessSellerBuyingCompany(
    listingModeIsLive,
    selectedSKU,
    listingDetails.storeID
  );

  let listingCompanyAddressCountryName = '';
  if (listingModeIsLive) {
    listingCompanyAddressCountryName = listingDetails.buyingCompany.companyAddressCountryName;
  } else {
    listingCompanyAddressCountryName = possibleDifferentSellerDetails.tempCompanyAddressCountryName;
  }

  const breadCrumbHtmlSpan = await buildComponentBreadcrumb(
    text1,
    link1,
    text2,
    link2,
    text3,
    link3,
    text4,
    link4,
    text5,
    link5
  );

  const middelSectionPrePriceHTML = renderHTMLMiddleSectionPrePrice(
    listingModeIsLive,
    listingDetails,
    linkStore,
    selectedSKU,
    possibleDifferentSellerDetails,
    lblSoldBy
  );

  const middelSectionPriceMOQHTML = renderHTMLMiddleSectionPriceMOQ(
    listingModeIsLive,
    listingDetails,
    lblMinimumOrder,
    selectedSKU
  );
  const middelSectionDiscountsHTML = renderHTMLMiddleSectionDiscounts(
    listingModeIsLive,
    selectedSKU,
    lblDiscounts
  );
  const middelSectionCustomasationsHTML = renderHTMLMiddleSectionCustomasations(
    listingModeIsLive,
    selectedSKU,
    lblCustomisable,
    lblMinimumOrder,
    lblCustomLogo,
    lblCustomPackaging,
    lblProductRedesign
  );
  const middelSectionTabRegionHTML = await renderHTMLMiddleSectionTabRegion(
    listingModeIsLive,
    selectedSKU,
    lblFeatures,
    lblSpec,
    lblReviews,
    lblFAQs,
    lblShippedFromCountry,
    lblCountryOfOrigin,
    lblCountryOfSeller,
    possibleDifferentSellerDetails,
    listingCompanyAddressCountryName,
    linkDashboard,
    lblWriteAReview,
    lblQuestion,
    lblAnswer,
    lblAskAQuestion
  );

  const middelSectionMainAddToCartButtonRegionHTML = renderHTMLMiddleSectionMainAddToCartButtonRegion(
    lblAddToCart,
    selectedSKU.moq
  );

  const rightSectionEstimatedDeliveryHTML = await renderHTMLRightSectionEstimatedDeliveryRegion(
    listingModeIsLive,
    selectedSKU,
    lblLeadTime,
    lblSameDay,
    lblDay,
    lblDays,
    lblTBC,
    lblEstimatedDelivery,
    lblBuyNow,
    lblContactSeller,
    lblWantItDeliveredFast,
    lblChooseExpressDeliveryAtCheckout,
    lblPayment,
    lblPayPayAccepted,
    lblCardsAccepted
  );

  const shareUrl = `${appState.BASE_URL}${productLinkForProduct}/${listingDetails.listing.listingID}/${listingDetails.listing.seoPageName}/${selectedSKU.skuid}`;

  const imageSliderSectionHTML = await buildComponentCatalogListingImageSlider(
    listingModeIsLive,
    selectedSKU,
    shareUrl,
    departmentID,
    categoryID,
    productID
  );

  const html = `

              <div class="MainContentContainer-Regular">

                ${breadCrumbHtmlSpan}
                <br>

                <div class="ActualProductForSaleAreaHeaderRowBasic">

                  <div class="ProductForSaleAreaHeadercol-35">
                      ${imageSliderSectionHTML}
                  </div>

                  <div class="ProductForSaleAreaHeadercol-65">

                    <div class="ProductForSaleAreaHeaderrowSubDetails">
                      <div class="ProductForSaleAreaHeaderSubDetails-col-70">                       

                        <div class="ProductForSaleAreaHeadercontainer">
                          <div class="ProductPageProductNameAndOptionsTopSection">
                            ${middelSectionPrePriceHTML}
                            ${middelSectionPriceMOQHTML}
                            ${middelSectionDiscountsHTML}
                            ${middelSectionCustomasationsHTML}
                          </div>
                           <div class="ProductPageFeaturesTabsContainer">
                            ${middelSectionTabRegionHTML}
                         
                          </div>
                          <div>
                             ${middelSectionMainAddToCartButtonRegionHTML}
                          </div>
                        </div>

                      </div>
                   

                      <div class="ProductForSaleAreaHeaderSubDetails-col-30">
                        ${rightSectionEstimatedDeliveryHTML}
                      </div>

                    </div>
                  </div>
                </div>             


              </div>


               <center>
           
            <div class="ProductPagedescriptionArea">

             <hr />

                <div class="DescriptionProductPageContainer-wrapper">
                    <div class="DescriptionProductPageContainer-title">

                        <h3>Product Description</h3>

                    </div>

                    <div class="DescriptionProductPageContainer-body">


                        ${selectedSKU.description}

                    </div>



                </div>


            </div>

           
                <div class="TrendingDiv"> <h2>Trending <b>Products</b></h2> </div>
           

            <br />
        </center>



`;

  return html;
}

export async function buildPageSkeleton() {
  const subDetails = await buildProductSkeletonSectionSubDetails();

  const text1 = '';
  const link1 = '';
  const text2 = '';
  const link2 = '';
  const text3 = '';
  const link3 = '';
  const text4 = '';
  const link4 = '';
  const text5 = '';
  const link5 = '';

  const breadCrumbHtmlSpan = await buildComponentBreadcrumb(
    text1,
    link1,
    text2,
    link2,
    text3,
    link3,
    text4,
    link4,
    text5,
    link5
  );

  const html = `
       <div class="MainContentContainer-Regular">

       ${breadCrumbHtmlSpan}


        <div class="ActualProductForSaleAreaHeaderRowBasic">
            <div class="ProductForSaleAreaHeadercol-35">

                    <div class="grid-blog-home-bottom-section-card my-fake-image-height-400">
                        <div class="my-site-lazy-loading-card">
                            <div class="my-site-lazy-loading-card-movement"></div>
                        </div>
                    </div>

                    <br />


                <div style="display:flex;height:100px;overflow:hidden;justify-content: space-between;">

                        <div class="grid-blog-home-bottom-section-card my-fake-image-height-and-width-80-by-80" style="display: inline-block;padding:5px;">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>
                        <div class="grid-blog-home-bottom-section-card my-fake-image-height-and-width-80-by-80" style="display: inline-block;padding:5px;">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>
                        <div class="grid-blog-home-bottom-section-card my-fake-image-height-and-width-80-by-80" style="display: inline-block;padding:5px;">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>
                        <div class="grid-blog-home-bottom-section-card my-fake-image-height-and-width-80-by-80" style="display: inline-block;padding:5px;">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>
                        <div class="grid-blog-home-bottom-section-card my-fake-image-height-and-width-80-by-80" style="display: inline-block;padding:5px;">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                </div>

            </div>

            <div class="ProductForSaleAreaHeadercol-65">

                <div class="ProductForSaleAreaHeaderrowSubDetails">
                    <div class="ProductForSaleAreaHeaderSubDetails-col-70">
                        ${subDetails}
                    </div>
                    <div class="ProductForSaleAreaHeaderSubDetails-col-30">
                        <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
                                <div class="my-site-lazy-loading-card">
                                    <div class="my-site-lazy-loading-card-movement"></div>
                                </div>
                            </div>

                            <br />
                            <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
                                <div class="my-site-lazy-loading-card">
                                    <div class="my-site-lazy-loading-card-movement"></div>
                                </div>
                            </div>

                            <br />
                            <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
                                <div class="my-site-lazy-loading-card">
                                    <div class="my-site-lazy-loading-card-movement"></div>
                                </div>
                            </div>

                            <br />
                            <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
                                <div class="my-site-lazy-loading-card">
                                    <div class="my-site-lazy-loading-card-movement"></div>
                                </div>
                            </div>

                            <br />
                            <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
                                <div class="my-site-lazy-loading-card">
                                    <div class="my-site-lazy-loading-card-movement"></div>
                                </div>
                            </div>

                            <br />
                            <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
                                <div class="my-site-lazy-loading-card">
                                    <div class="my-site-lazy-loading-card-movement"></div>
                                </div>
                            </div>

                            <br />
                            <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
                                <div class="my-site-lazy-loading-card">
                                    <div class="my-site-lazy-loading-card-movement"></div>
                                </div>
                            </div>

                            <br />

                    </div>
                </div>




            </div>

        </div>
    </div>
    `;

  return html;
}
function buildProductSkeletonSectionSubDetails() {
  const cardHtml = `
        <div class="grid-blog-home-bottom-section-card my-fake-image-height-50">
            <div class="my-site-lazy-loading-card">
                <div class="my-site-lazy-loading-card-movement"></div>
            </div>
        </div>
        <br />
        `;

  let html = '';

  for (let i = 0; i < 16; i++) {
    html += cardHtml;
  }

  return html;
}

function renderStarRating(customerRating) {
  const baseURL = `${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/star/`;
  const fullStar = `${baseURL}star-48.png`;
  const emptyStar = `${baseURL}star-o-48.png`;
  const maxStars = 5;

  // Calculate number of full and empty stars
  const fullStarsCount = Math.min(Math.max(Math.floor(customerRating), 0), maxStars); // Ensure between 0 and 5
  const emptyStarsCount = maxStars - fullStarsCount;

  // Generate the star HTML
  const fullStarsHtml = Array(fullStarsCount)
    .fill(
      `<img src="${fullStar}" width="20" height="20" loading="eager" alt="" style="width:20px;height:20px;">`
    )
    .join('');
  const emptyStarsHtml = Array(emptyStarsCount)
    .fill(
      `<img src="${emptyStar}" width="20" height="20" loading="eager" alt="" style="width:20px;height:20px;">`
    )
    .join('');

  // Combine the full and empty stars
  return `${fullStarsHtml}${emptyStarsHtml}`;
}

function renderHTMLMiddleSectionPrePrice(
  listingModeIsLive,
  listingDetails,
  linkStore,
  selectedSKU,
  possibleDifferentSellerDetails,
  lblSoldBy
) {
  const builtRatingStars = renderStarRating(listingDetails.listing.customerRating);

  let otherSellerName = '';
  let otherSellerNameTemp = '';

  if (possibleDifferentSellerDetails.buyingCompanyID > 0 && listingModeIsLive) {
    otherSellerName = possibleDifferentSellerDetails.companyName;
  }

  if (possibleDifferentSellerDetails.tempBuyingCompanyID > 0 && !listingModeIsLive) {
    otherSellerNameTemp = possibleDifferentSellerDetails.tempCompanyName;
  }

  const soldByRegionLiveHTLM =
    otherSellerName.length > 0
      ? `  <div class="titleProductPage-Span-Seller">     ${lblSoldBy}: ${otherSellerName}    </div>`
      : '';
  const soldByRegionPreviewHTLM =
    otherSellerNameTemp.length > 0
      ? `  <div class="titleProductPage-Span-Seller">     ${lblSoldBy}: ${otherSellerNameTemp}    </div>`
      : '';

    let htmlLive = `

    <h1 class="titleProductPageProductName"> ${listingDetails.listing.name} <span class="ActualAdvertbadge" id="IsNewSpan">  New  </span> </h1>
    `;

 //     htmlLive += `

 //   <h1 class="titleProductPageProductName"> ${listingDetails.listing.name} <span class="ActualAdvertbadge" id="IsNewSpan">  New  </span> </h1>
 //   <h6 class="titleProductPageProductName">
 //   MyLoggedInUserID ${appState.MyLoggedInUserID} <br> 
 //MyBuyingEntityID ${appState.MyBuyingEntityID} <br> 
 //MyBuyingEntityType ${appState.MyBuyingEntityType}</h6>

 // `;

    htmlLive += `
       
    <span id="RatingSpan" class="ActualProduct-rating">
      ${builtRatingStars}
    </span>

    <span class="titleProductPageProductspan">
      SKU: ${selectedSKU.skuCode}
    </span>

    <div class="titleProductPage-Span-StoreName">
      <a href="${linkStore}/${listingDetails.buyingCompany.companyBrandName}/${listingDetails.buyingCompany.buyingCompanyID}/${listingDetails.buyingCompany.seoPageName}"
        target="_blank">
        ${listingDetails.buyingCompany.companyBrandName}
      </a>
    </div>

    <div class="titleProductPage-Span-StoreName">
      Seller:
      <a href="${linkStore}/${listingDetails.buyingCompany.companyBrandName}/${listingDetails.buyingCompany.buyingCompanyID}/${listingDetails.buyingCompany.seoPageName}"
        target="_blank">
        ${listingDetails.buyingCompany.companyName}
        ${listingDetails.buyingCompany.companyTypeAbv} -
        ${listingDetails.buyingCompany.companyAddressStateName},
        ${listingDetails.buyingCompany.companyAddressCountryName}
      </a>
    </div>

     ${soldByRegionLiveHTLM}

    

  `;

  const htmlPreview = `

    <h1 class="titleProductPageProductName"> ${listingDetails.listing.tempName} <span class="ActualAdvertbadge" id="IsNewSpan">  New  </span> </h1>

    <span id="RatingSpan" class="ActualProduct-rating">
      ${builtRatingStars}
    </span>

    <span class="titleProductPageProductspan">
      SKU: ${selectedSKU.skuCode}
    </span>

    <div class="titleProductPage-Span-StoreName">
      <a href="${linkStore}/${listingDetails.buyingCompany.tempCompanyBrandName}/${listingDetails.buyingCompany.buyingCompanyID}/${listingDetails.buyingCompany.seoPageName}"
        target="_blank">
        ${listingDetails.buyingCompany.tempCompanyBrandName}
      </a>
    </div>

    <div class="titleProductPage-Span-StoreName">
      Seller:
      <a href="${linkStore}/${listingDetails.buyingCompany.tempCompanyBrandName}/${listingDetails.buyingCompany.buyingCompanyID}/${listingDetails.buyingCompany.seoPageName}"
        target="_blank">
        ${listingDetails.buyingCompany.tempCompanyName}
        ${listingDetails.buyingCompany.tempCompanyTypeAbv} -
        ${listingDetails.buyingCompany.tempCompanyAddressStateName},
        ${listingDetails.buyingCompany.tempCompanyAddressCountryName}
      </a>
    </div>

    ${soldByRegionPreviewHTLM}
  

  `;

  if (listingModeIsLive) {
    return htmlLive;
  } else {
    return htmlPreview;
  }
}

function renderHTMLMiddleSectionPriceMOQ(
  listingModeIsLive,
  listingDetails,
  lblMinimumOrder,
  selectedSKU
) {
  const symbolDirection = getCurrencyCultureSymbolOnLeftOrRight(appState.SiteLanguageCookie);

  const priceToDisplay = convertNumberStringFromUKFormatToAnyLanguageFormatDouble(
    selectedSKU.skuPrice,
    appState.SiteLanguageCookie
  );

  const currencySignToDisplay =
    priceToDisplay > 1
      ? appState.SiteCurrencySignMultipleCookie
      : appState.SiteCurrencySignSingleCookie;

  //"unitOfMeasureABVSingle": "pc",
  //    "unitOfMeasureABVMultiple": "pcs",
  //        "unitOfMeasureNameSingle": "Piece",
  //    "unitOfMeasureNameMultiple": "Pieces",

  //sku specific
  const uomSingle = selectedSKU.unitOfMeasureABVSingle;
  const uomMultiple = selectedSKU.unitOfMeasureABVMultiple;
  const moq = selectedSKU.moq;
  const moqToDisplay = convertNumberStringFromUKFormatToAnyLanguageFormatDouble(
    moq,
    appState.SiteLanguageCookie
  );

  const priceSectionDisplayLeft = `
      <div class="titleProductPageProductPrice" id="divPriceWrapperLeft">
        ${currencySignToDisplay}
        <span class="titleProductPageProductPriceSpan">${priceToDisplay}</span>
        / ${uomSingle}
      </div>
    `;

  const priceSectionDisplayRight = `
      <div class="titleProductPageProductPrice" id="divPriceWrapperRight">
        <span class="titleProductPageProductPriceSpan">${priceToDisplay}</span>
        ${currencySignToDisplay}
        / ${uomSingle}
      </div>
    `;

  const finalPriceSectionDisplay =
    symbolDirection === 'left' ? priceSectionDisplayLeft : priceSectionDisplayRight;

  const moqSectionDisplaySingle = `   <div>  ${lblMinimumOrder} (${moq} ${uomSingle})</div>    `;

  const moqSectionDisplayMultiple = ` <div>  ${lblMinimumOrder} (${moq} ${uomMultiple})</div>    `;

  const moqSectionDisplay =
    selectedSKU.moq > 1 ? moqSectionDisplayMultiple : moqSectionDisplaySingle;

  return `

    
    ${finalPriceSectionDisplay}
      ${moqSectionDisplay}





      `;
}

function renderHTMLMiddleSectionDiscounts(listingModeIsLive, selectedSKU, lblDiscounts) {
  // parse floats/ints
  const percentage1 = convertStringToDecimal(selectedSKU.discountPercentage1),
    discountQty1 = convertStringToDecimal(selectedSKU.discountQTY1);
  const percentage2 = convertStringToDecimal(selectedSKU.discountPercentage2),
    discountQty2 = convertStringToDecimal(selectedSKU.discountQTY2);
  const percentage3 = convertStringToDecimal(selectedSKU.discountPercentage3),
    discountQty3 = convertStringToDecimal(selectedSKU.discountQTY3);

  //if any of the values less than 0 set to 0
  if (percentage1 < 0) {
    percentage1 = 0;
  }
  if (percentage2 < 0) {
    percentage2 = 0;
  }
  if (percentage3 < 0) {
    percentage3 = 0;
  }

  if (percentage1 === 0 && percentage2 === 0 && percentage3 === 0) {
    return '';
  }

  let divDiscountsIsVisible1 = true;
  let divDiscountsIsVisible2 = true;
  let divDiscountsIsVisible3 = true;

  let finalDiscountLableText1 = '';
  let finalDiscountLableText2 = '';
  let finalDiscountLableText3 = '';

  // alert(`discountQty1 : ${discountQty1} : percentage1 : ${percentage1} : selectedSKU.OfferDiscount : ${selectedSKU.offerDiscount}`);
  if (discountQty1 <= 0 || percentage1 <= 0 || selectedSKU.offerDiscount != true) {
    divDiscountsIsVisible1 = false;
  } else {
    finalDiscountLableText1 = renderDiscountRow(
      listingModeIsLive,
      selectedSKU.skuPrice,
      selectedSKU.discountQTY1,
      selectedSKU.discountPercentage1,
      selectedSKU.unitOfMeasureABVSingle,
      selectedSKU.unitOfMeasureABVMultiple
    );
  }

  //  alert(`discountQty2 : ${discountQty2} : percentage2 : ${percentage2} : selectedSKU.OfferDiscount2 : ${selectedSKU.offerDiscount2}`);
  if (discountQty2 <= 0 || percentage2 <= 0 || selectedSKU.offerDiscount2 != true) {
    divDiscountsIsVisible2 = false;
  } else {
    finalDiscountLableText2 = renderDiscountRow(
      listingModeIsLive,
      selectedSKU.skuPrice,
      selectedSKU.discountQTY2,
      selectedSKU.discountPercentage2,
      selectedSKU.unitOfMeasureABVSingle,
      selectedSKU.unitOfMeasureABVMultiple
    );
  }

  // alert(`discountQty3 : ${discountQty3} : percentage3 : ${percentage3} : selectedSKU.OfferDiscount3 : ${selectedSKU.offerDiscount3}`);
  if (discountQty3 <= 0 || percentage3 <= 0 || selectedSKU.offerDiscount3 != true) {
    divDiscountsIsVisible3 = false;
  } else {
    finalDiscountLableText3 = renderDiscountRow(
      listingModeIsLive,
      selectedSKU.skuPrice,
      selectedSKU.discountQTY3,
      selectedSKU.discountPercentage3,
      selectedSKU.unitOfMeasureABVSingle,
      selectedSKU.unitOfMeasureABVMultiple
    );
  }

  if (
    divDiscountsIsVisible1 === false &&
    divDiscountsIsVisible2 === false &&
    divDiscountsIsVisible3 === false
  ) {
    return '';
  }

  let html = `
      <div id="divDiscounts" class="ListingPageToggleDivLikeCustomasation">
        <div id="divDiscountsHeader" style="display:block;cursor:pointer;" >

        ${lblDiscounts}    <img alt=""  id="imgToggleDiscounts"   width="20" height="20"  src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-toggle-up.svg"  style="width:20px;height:20px;" class="cartTopNewButton-Image-toggle-icon-rotated">
        
        </div>
        <div  id="divDiscountsContent" class="ListingPageToggleDivLikeCustomasation-Content" >
        ${finalDiscountLableText1}
        ${finalDiscountLableText2}
        ${finalDiscountLableText3}

        </div>

      </div>
    `;

  return html;
}

function renderDiscountRow(
  listingModeIsLive,
  skuPrice,
  discountQuantity,
  discountPercentage,
  unitOfMeasureABVSingle,
  unitOfMeasureABVMultiple
) {
  //assume values already validated

  //// calculate discounted price
  const basePrice = convertStringToDecimal(skuPrice);
  const discountQty = convertStringToDecimal(discountQuantity);
  const discountRate = convertStringToDecimal(discountPercentage);

  const discounted = basePrice * (1 - discountRate / 100);

  const discountedDisplay = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    discounted,
    appState.SiteLanguageCookie,
    appState.SiteCurrencySignSingleCookie,
    appState.SiteCurrencySignMultipleCookie,
    appState.SiteCurrencyRateCookie
  );

  //// pick singular or multiple UOM
  const uomSingle = unitOfMeasureABVSingle;
  const uomMulti = unitOfMeasureABVMultiple;
  const uom = discountQty > 1 ? uomMulti : uomSingle;

  return ` <div> ${discountQty} ${uom} > ${discountedDisplay}  / ${uomSingle} </div> `;
}

function renderHTMLMiddleSectionCustomasations(
  listingModeIsLive,
  selectedSKU,
  lblCustomisable,
  lblMinimumOrder,
  lblCustomLogo,
  lblCustomPackaging,
  lblProductRedesign
) {
  if (selectedSKU.offerCustomisation === false) {
    return '';
  }

  // parse floats/ints
  const customLogoMOQ = convertStringToDecimal(selectedSKU.customLogoMOQ);
  const customPackagingMOQ = convertStringToDecimal(selectedSKU.customPackagingMOQ);
  const productRedesignMOQ = convertStringToDecimal(selectedSKU.productRedesignMOQ);

  //if any of the values less than 0 set to 0
  if (customLogoMOQ < 0) {
    customLogoMOQ = 0;
  }
  if (customPackagingMOQ < 0) {
    customPackagingMOQ = 0;
  }
  if (productRedesignMOQ < 0) {
    productRedesignMOQ = 0;
  }

  if (customLogoMOQ === 0 && customPackagingMOQ === 0 && productRedesignMOQ === 0) {
    return '';
  }

  let divIsVisibleCustomLogoMOQ = true;
  let divIsVisibleCustomPackagingMOQ = true;
  let divIsVisibleProductRedesignMOQ = true;

  let finalLableTextCustomLogo = '';
  let finalLableTextCustomPackaging = '';
  let finalLableTextProductRedesign = '';

  //  alert(`customLogoMOQ : ${customLogoMOQ} : customPackagingMOQ : ${customPackagingMOQ} : productRedesignMOQ : ${productRedesignMOQ}`);

  if (customLogoMOQ <= 0 || selectedSKU.offerCustomLogo != true) {
    divIsVisibleCustomLogoMOQ = false;
  } else {
    finalLableTextCustomLogo = `<div> ${lblCustomLogo} - ${lblMinimumOrder} (${customLogoMOQ} ${
      customLogoMOQ > 1 ? selectedSKU.unitOfMeasureABVMultiple : selectedSKU.unitOfMeasureABVSingle
    })</div>`;
  }

  // alert(`customLogoMOQ : ${customLogoMOQ} : customPackagingMOQ : ${customPackagingMOQ} : productRedesignMOQ : ${productRedesignMOQ}`);

  if (customPackagingMOQ <= 0 || selectedSKU.offerCustomPackaging != true) {
    divIsVisibleCustomPackagingMOQ = false;
  } else {
    finalLableTextCustomPackaging = `<div> ${lblCustomPackaging} - ${lblMinimumOrder} (${customPackagingMOQ} ${
      customPackagingMOQ > 1
        ? selectedSKU.unitOfMeasureABVMultiple
        : selectedSKU.unitOfMeasureABVSingle
    })</div>`;
  }

  // alert(`customLogoMOQ : ${customLogoMOQ} : customPackagingMOQ : ${customPackagingMOQ} : productRedesignMOQ : ${productRedesignMOQ}`);

  if (productRedesignMOQ <= 0 || selectedSKU.offerProductRedesign != true) {
    divIsVisibleProductRedesignMOQ = false;
  } else {
    finalLableTextProductRedesign = `<div> ${lblProductRedesign} - ${lblMinimumOrder} (${productRedesignMOQ} ${
      productRedesignMOQ > 1
        ? selectedSKU.unitOfMeasureABVMultiple
        : selectedSKU.unitOfMeasureABVSingle
    })</div>`;
  }

  if (
    divIsVisibleCustomLogoMOQ === false &&
    divIsVisibleCustomPackagingMOQ === false &&
    divIsVisibleProductRedesignMOQ === false
  ) {
    // alert(`divIsVisibleCustomLogoMOQ : ${divIsVisibleCustomLogoMOQ} : divIsVisibleCustomPackagingMOQ : ${divIsVisibleCustomPackagingMOQ} : divIsVisibleProductRedesignMOQ : ${divIsVisibleProductRedesignMOQ}`);
    return '';
  }

  let html = `
       <div id="divCustomizable" class="ListingPageToggleDivLikeCustomasation">
        <div id="divCustomisationsHeader" style="display:block;cursor:pointer;" >

        ${lblCustomisable}  <img alt=""  id="imgToggleCustomisations"   width="20" height="20"  src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-toggle-up.svg"  style="width:20px;height:20px;" class="cartTopNewButton-Image-toggle-icon-rotated">
        
        </div>
        <div id="divCustomisationsContent" class="ListingPageToggleDivLikeCustomasation-Content">
        ${finalLableTextCustomLogo}
        ${finalLableTextCustomPackaging}
        ${finalLableTextProductRedesign}

        </div>

      </div>
    `;

  return html;
}

async function renderHTMLMiddleSectionTabRegion(
  listingModeIsLive,
  selectedSKU,
  lblFeatures,
  lblSpec,
  lblReviews,
  lblFAQs,
  lblShippedFromCountry,
  lblCountryOfOrigin,
  lblCountryOfSeller,
  possibleDifferentSellerDetails,
  listingCompanyAddressCountryName,
  linkDashboard,
  lblWriteAReview,
  lblQuestion,
  lblAnswer,
  lblAskAQuestion
) {
  const featuresHTML = renderHTMLTabFeatures(listingModeIsLive, selectedSKU);
  const specsHTML = await renderHTMLTabSpecs(
    listingModeIsLive,
    selectedSKU,
    lblShippedFromCountry,
    lblCountryOfOrigin,
    lblCountryOfSeller,
    possibleDifferentSellerDetails,
    listingCompanyAddressCountryName
  );

  const reviewsHTML = await renderHTMLTabReviews(
    listingModeIsLive,
    selectedSKU,
    linkDashboard,
    lblWriteAReview
  );

  const faqsHTML = await renderHTMLTabFAQs(
    listingModeIsLive,
    selectedSKU,
    lblQuestion,
    lblAnswer,
    lblAskAQuestion
  );

  const html = `

       <input type="radio" id="tabone" Text="Features" name="tabGroup1b" Checked />  <label for="tabone">Features</label>

                                    <div class="tab">

                                   ${featuresHTML}

                                    </div>
                                    

                                      <input type="radio" id="tabTwo" Text="Features" name="tabGroup1b" /> <label for="tabTwo">Spec</label>
                                    <div class="tab">
                                 ${specsHTML}
                                    </div>

                                      <input type="radio" id="tabThree" Text="Reviews" name="tabGroup1b" /> <label for="tabThree">Reviews</label>
                                    <div class="tab">
                                     ${reviewsHTML}
                                    </div>


                                      <input type="radio" id="tabFour" Text="FAQs" name="tabGroup1b" /> <label for="tabFour">FAQs</label>
                                    <div class="tab">
                                    ${faqsHTML}
                                    </div>
    `;

  return html;
}

function renderHTMLTabFeatures(listingModeIsLive, selectedSKU) {
  // collect features in an array so we can loop
  const features = [
    selectedSKU.feature1,
    selectedSKU.feature2,
    selectedSKU.feature3,
    selectedSKU.feature4,
    selectedSKU.feature5,
    selectedSKU.feature6,
    selectedSKU.feature7,
    selectedSKU.feature8,
    selectedSKU.feature9,
  ];

  const rowsHtml = features
    .map((feat, idx) => {
      if (!feat || !feat.trim()) return ''; // skip empty/null
      return `
        <div class="basicTableRow SideBarSearchFilters-row" id="divFeatureRow${idx + 1}">
          <div class="basicTableCell SideBarSearchFilters-cell-checkbox">&#8226;</div>
          <div class="basicTableCell SideBarSearchFilters-cell-title">${feat}</div>
        </div>`;
    })
    .join('\n');

  return `
    <div class="ProductPageFeaturesTab-ProductFeaturesContainer">
      <div class="basicTable SideBarSearchFilters-table">
        ${rowsHtml}
      </div>
    </div>`;
}

async function renderHTMLTabSpecs(
  listingModeIsLive,
  selectedSKU,
  lblShippedFromCountry,
  lblCountryOfOrigin,
  lblCountryOfSeller,
  possibleDifferentSellerDetails,
  listingCompanyAddressCountryName
) {
  // return "testsing specs";

  const skuId = selectedSKU.skuid;
  const lang = appState.SiteLanguageCookie;

  // 1) fetch raw specs & options rows
  let rows = [];
  if (listingModeIsLive) {
    rows = await fetchSKUProductSpecAndOptionsLive(skuId);
  } else {
    rows = await fetchSKUProductSpecAndOptionsLive(
      //   rows = await sellerAPI.getSKUProductSpecAndOptionsTemp(
      skuId,
      lang,
      appState.MyUserID,
      appState.MyBuyingEntityID,
      appState.MyBuyingEntityType
    );
  }

  // 2) sort by spec-order then option-order
  rows.sort(
    (a, b) =>
      a.productSpecDisplayOrder - b.productSpecDisplayOrder ||
      a.productSpecOptionDisplayOrder - b.productSpecOptionDisplayOrder
  );

  // 3) build a unique spec list (in display order)
  const specs = Array.from(
    rows
      .reduce((m, item) => {
        if (!m.has(item.productSpecID)) {
          m.set(item.productSpecID, {
            specId: item.productSpecID.toString(),
            specName: item.productSpecName,
          });
        }
        return m;
      }, new Map())
      .values()
  );

  // 4) append the three “temp” specs at the end
  specs.push(
    { specId: 'tempShippedFromCountry', specName: lblShippedFromCountry },
    { specId: 'tempCountryOfOrigin', specName: lblCountryOfOrigin },
    { specId: 'tempCountryOfSeller', specName: lblCountryOfSeller }
  );

  // 5) for each spec, build its comma-separated options string
  const tableMap = {};
  for (const { specId, specName } of specs) {
    tableMap[specName] = await _getOptionsForSpecAsString(
      listingModeIsLive,
      specId,
      selectedSKU,
      rows,
      possibleDifferentSellerDetails,
      listingCompanyAddressCountryName
    );
  }

  // 6) render HTML
  const rowsHtml = Object.entries(tableMap)
    .map(
      ([name, opts]) => `
      <tr>
        <td>${name}</td>
        <td>${opts}</td>
      </tr>`
    )
    .join('\n');

  return `
    <div id="idProductSpec" class="AddEditProductPage-SpecContainer">
      <table>
        ${rowsHtml}
      </table>
    </div>`;
}

async function _getOptionsForSpecAsString(
  listingModeIsLive,
  specId,
  selectedSKU,
  allRows,
  possibleDifferentSellerDetails,
  listingCompanyAddressCountryName
) {
  // shipped-from-country
  if (specId === 'tempShippedFromCountry') {
    const guess =
      listingModeIsLive === true
        ? await fetchBestGuessShippedFromCountryIDOnlyBySKUIDANDShipToCatalogSearchAsyncLive(
            selectedSKU.skuid
          )
        : await fetchBestGuessShippedFromCountryIDOnlyBySKUIDANDShipToCatalogSearchTempForPreviewAsyncLive(
            selectedSKU.skuid
          );
    return guess?.name || '';

    // country-of-origin
  } else if (specId === 'tempCountryOfOrigin') {
    return selectedSKU.countryOfOriginName || '';

    // country-of-seller
  } else if (specId === 'tempCountryOfSeller') {
    if (possibleDifferentSellerDetails.buyingCompanyID > 0) {
      // alert("possibleDifferentSellerDetails.buyingCompanyID > 0");

      return possibleDifferentSellerDetails.companyAddressCountryName;
    } else {
      if (listingModeIsLive === true) {
        //  alert("listingModeIsLive === true");

        return listingCompanyAddressCountryName;
      } else {
        // alert("listingModeIsLive === false");

        return listingCompanyAddressCountryName;
      }
    }

    // “real” specs
  } else {
    const matches = allRows
      .filter(r => r.productSpecID.toString() === specId)
      .map(r => r.productSpecOptionName)
      .filter(n => n && n.trim().length)
      .join(', ');
    return matches;
  }
}

async function renderHTMLTabReviews(
  listingModeIsLive,
  selectedSKU,
  linkDashboard,
  lblWriteAReview
) {
  // 1. preview-mode placeholder
  if (listingModeIsLive !== true) {
    return `
      <div class="ProductPageReviewsTab-ReviewsContainer">
        <center>
          <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
          <span class="ProductPageWriteReviewButton"> In preview mode</span>
        </center>
      </div>
    `;
  }

  // 2. fetch reviews
  const reviews = await fetchGetAllProductReviewsByListingIDAsync(selectedSKU.skuListingID);

  // 2. no reviews yet → write-review button
  if (!Array.isArray(reviews) || reviews.length === 0) {
    return `
      <div class="ProductPageReviewsTab-ReviewsContainer">
        <center>
          <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
          <a href="${linkDashboard}" class="ProductPageWriteReviewButton"> ${lblWriteAReview}</a>
        </center>
      </div>
    `;
  }

  // 3. render each review
  const dtf = new Intl.DateTimeFormat(appState.SiteLanguageCookie, {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  const starImg = filled =>
    filled
      ? `<img width="18" height="18" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/star/star-48.png" style="width:18px;height:18px;">`
      : `<img width="18" height="18" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/star/star-o-48.png" style="width:18px;height:18px;">`;

  const itemsHtml = reviews
    .map(row => {
      // stars: floor(rating) filled, rest empty
      const full = Math.min(5, Math.max(0, Math.floor(row.rating)));
      const empty = 5 - full;
      let stars = '';
      for (let i = 0; i < full; i++) stars += starImg(true);
      for (let i = 0; i < empty; i++) stars += starImg(false);

      // date formatting
      const createdDate = dtf.format(new Date(row.dateCreated));
      let adminResponseHtml = '';
      if (row.adminResponse && row.adminResponse.trim()) {
        const respondedDate = dtf.format(new Date(row.dateAdminResponded));
        adminResponseHtml = `
        <div class="ReviewContainer-AdminResponseContainer">
          <span class="ReviewContainer-AdminResponseContainer-Title">
            Response from Seller - <span>${respondedDate}</span>
          </span>
          <span class="ReviewContainer-AdminResponseContainer-Content">
            ${row.adminResponse}
          </span>
        </div>
      `;
      }

      return `
      <div class="ProductPageReviewsTab-ReviewsContainer">
        <span class="ReviewContainer-Stars">${stars}</span>
        <span class="ReviewContainer-CustomerNameSection">
          ${row.name} - <span>${createdDate}</span>
        </span>
        <span class="ReviewContainer-ReviewTitle">${row.title}</span>
        <span class="ReviewContainer-ReviewContent">${row.description}</span>
        ${adminResponseHtml}
      </div>
    `;
    })
    .join('');

  // 4. write-review button
  const writeReviewHtml = `
    <br />
                                                    <br />
                                                  
                                                  
          <a href="${linkDashboard}" class="ProductPageWriteReviewButton"> ${lblWriteAReview}</a>
            <br />
            <br />
            <br />
          `;
  // 5. combine
  const itemsHtmlWithButton = `
      <div class="ProductPageReviewsTab-ReviewsContainer">
        ${itemsHtml}
        <center>
          ${writeReviewHtml}
        </center>
      </div>
    `;

  return itemsHtmlWithButton;
}

async function renderHTMLTabFAQs(
  listingModeIsLive,
  selectedSKU,
  lblQuestion,
  lblAnswer,
  lblAskAQuestion
) {
  const faqs = listingModeIsLive
    ? await fetchGetAllSKUFAQBySKUIDLiveAsync(selectedSKU.skuid)
    : await fetchGetAllSKUFAQBySKUIDLiveAsync(selectedSKU.skuid);
  //GetAllSKUFAQBySKUIDTempFlippedForPreviewAsync

  // Early return if no FAQs
  if (!Array.isArray(faqs) || faqs.length === 0) {
    return '';
  }

  // Build table rows
  const rowsHtml = faqs
    .map(
      faq => `
    <tr style="vertical-align:top;">
      <td><span class="QA-SectionTitle">${lblQuestion}:</span></td>
      <td><span class="QA-SectionQuestionTitle">${faq.question}</span></td>
    </tr>
    <tr style="vertical-align:top;">
      <td><span class="QA-SectionTitle"> ${lblAnswer}:</span></td>
      <td>
        <span class="QA-SectionQuestionAnswer">${faq.answer}</span>
        <br/><br/>
      </td>
    </tr>
  `
    )
    .join('');

  // Full container
  const html = `
    <div class="ProductPageFeaturesTab-FAQContainer">
      <table>
        ${rowsHtml}
      </table>
      <center>
          <br />
          <br />
          
        <button id="AskButton" class="AskquesButton"> ${lblAskAQuestion} </button>
        <br />
          <br />
          <br />
      </center>
    </div>
  `;

  return html;
}

function renderHTMLMiddleSectionMainAddToCartButtonRegion(lblAddToCart, moq) {
  return `

    <div class="ProductPagebuybtn-grid">

                                    <label class="ProductPagebuybtn-div-Quantity-Title">Quantity</label>
                                     <label id="lblMOQQty" style="display:none;">${moq}</label>


                                    <div class="ProductPagebuybtn-qty-grid">
                                        <button id="btnDecreaseQty" class="ProductPagebuybtn-div-btn-Decrease">-</button>
                                        <input  type="text" id="txtAddToCartQyt" value="${moq}" class="ProductPagebuybtn-div-txt-Quantity" />
                                        <button id="btnIncreaseQty" class="ProductPagebuybtn-div-btn-Increase" >+</button>
                                    </div>

                                    <button ID="addToCartButton" class="ProductPagebuybtn"> ${lblAddToCart} </button>
                                     
    
                            </div>

`;
}

async function renderHTMLRightSectionEstimatedDeliveryRegion(
  listingModeIsLive,
  selectedSKU,
  lblLeadTime,
  lblSameDay,
  lblDay,
  lblDays,
  lblTBC,
  lblEstimatedDelivery,
  lblBuyNow,
  lblContactSeller,
  lblWantItDeliveredFast,
  lblChooseExpressDeliveryAtCheckout,
  lblPayment,
  lblPayPayAccepted,
  lblCardsAccepted
) {
  const leadTimesHTML = await renderHTMLRightSectionLeadTime(
    listingModeIsLive,
    selectedSKU,
    lblLeadTime,
    lblSameDay,
    lblDay,
    lblDays,
    lblTBC
  );
  const buyNowButtonSectionHTML = await renderHTMLRightSectionBuyNowButton(
    listingModeIsLive,
    selectedSKU,
    lblBuyNow,
    lblContactSeller
  );

  return `
    <div class="ProductForSaleAreaDeliveryNote">

                                <strong>   ${lblEstimatedDelivery}</strong> <br />

                                ${leadTimesHTML}

                                <br />

                                <strong>   ${lblWantItDeliveredFast}</strong>
                               <br />  ${lblChooseExpressDeliveryAtCheckout}

                                <br /><br />

                                  ${buyNowButtonSectionHTML}

                                  <br /><br />
                                <h3>${lblPayment}</h3>
                                <br />
                                <img style="height:30px;margin-right:0.2rem;margin-top:0.2rem;"  width="44" height="30" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pay/sty1/svg/Visa.svg" />
                                <img style="height:30px;margin-right:0.2rem;margin-top:0.2rem;"  width="44" height="30" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pay/sty1/svg/Amex.svg"  />
                                <img style="height:30px;margin-right:0.2rem;margin-top:0.2rem;" width="44" height="30" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pay/sty1/svg/Mastercard.svg" />
                                <img style="height:30px;margin-right:0.2rem;margin-top:0.2rem;"  width="44" height="30" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pay/sty1/svg/UnionPay.svg"  />
                                <img style="height:30px;margin-right:0.2rem;margin-top:0.2rem;"  width="44" height="30" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pay/sty1/svg/JCB.svg"  />
                                <img style="height:30px;margin-right:0.2rem;margin-top:0.2rem;"  width="44" height="30" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pay/sty1/svg/PayPal.svg"  />

                                <br /> <br />
                                ${lblPayPayAccepted} <br />
                                ${lblCardsAccepted}





                                </div>


            `;
}

async function renderHTMLRightSectionLeadTime(
  listingModeIsLive,
  selectedSKU,
  lblLeadTime,
  lblSameDay,
  lblDay,
  lblDays,
  lblTBC
) {
  // parse floats/ints
  const leadQty1 = convertStringToInt(selectedSKU.leadQty1);
  const leadDays1 = convertStringToInt(selectedSKU.leadDays1);
  const leadQty2 = convertStringToInt(selectedSKU.leadQty2);
  const leadDays2 = convertStringToInt(selectedSKU.leadDays2);
  const leadQty3 = convertStringToInt(selectedSKU.leadQty3);
  const leadDays3 = convertStringToInt(selectedSKU.leadDays3);

  const leadQty4 = convertStringToInt(selectedSKU.leadQty4);

  //if any of the values less than 0 set to 0
  if (leadQty1 < 0) {
    leadQty1 = 0;
  }
  if (leadQty2 < 0) {
    leadQty2 = 0;
  }
  if (leadQty3 < 0) {
    leadQty3 = 0;
  }

  if (leadQty4 < 0) {
    leadQty4 = 0;
  }

  if (leadQty1 === 0 && leadQty2 === 0 && leadQty3 === 0 && leadQty4 === 0) {
    return '';
  }

  let divLeadsIsVisible1 = true;
  let divLeadsIsVisible2 = true;
  let divLeadsIsVisible3 = true;
  let divLeadsIsVisible4 = true;

  let finalLeadsLableText1 = '';
  let finalLeadsLableText2 = '';
  let finalLeadsLableText3 = '';
  let finalLeadsLableText4 = '';

  //alert(`leadQty1 : ${leadQty1} : leadDays1 : ${leadDays1} : leadQty2 : ${leadQty2} : leadDays2 : ${leadDays2}: leadQty3 : ${leadQty3} : leadDays3 : ${leadDays3} : leadQty4 : ${leadQty4} `);

  if (leadQty1 <= 0) {
    divLeadsIsVisible1 = false;
  } else {
    finalLeadsLableText1 = renderLeadTimeRow(
      listingModeIsLive,
      leadQty1,
      leadDays1,
      lblSameDay,
      lblDay,
      lblDays,
      lblTBC,
      selectedSKU.unitOfMeasureABVSingle,
      selectedSKU.unitOfMeasureABVMultiple
    );
  }

  // alert(`leadQty2 : ${leadQty2} : leadDays2 : ${leadDays2} : selectedSKU.offerDiscount2 : ${selectedSKU.offerDiscount2}`);
  if (leadQty2 <= 0) {
    divLeadsIsVisible2 = false;
  } else {
    finalLeadsLableText2 = renderLeadTimeRow(
      listingModeIsLive,
      leadQty2,
      leadDays2,
      lblSameDay,
      lblDay,
      lblDays,
      lblTBC,
      selectedSKU.unitOfMeasureABVSingle,
      selectedSKU.unitOfMeasureABVMultiple
    );
  }

  // alert(`leadQty3 : ${leadQty3} : leadDays3 : ${leadDays3} : selectedSKU.offerDiscount3 : ${selectedSKU.offerDiscount3}`);
  if (leadQty3 <= 0) {
    divLeadsIsVisible3 = false;
  } else {
    finalLeadsLableText3 = renderLeadTimeRow(
      listingModeIsLive,
      leadQty3,
      leadDays3,
      lblSameDay,
      lblDay,
      lblDays,
      lblTBC,
      selectedSKU.unitOfMeasureABVSingle,
      selectedSKU.unitOfMeasureABVMultiple
    );
  }

  // alert(`leadQty4 : ${leadQty4} : selectedSKU.offerDiscount3 : ${selectedSKU.offerDiscount3}`);
  if (leadQty4 <= 0) {
    divLeadsIsVisible4 = false;
  } else {
    //  finalLeadsLableText4 = renderLeadTimeRow(listingModeIsLive, leadQty4, null, lblSameDay, lblDay, lblDays, lblTBC, selectedSKU.unitOfMeasureABVSingle, selectedSKU.unitOfMeasureABVMultiple);

    const uom =
      leadQty4 > 1 ? selectedSKU.unitOfMeasureABVMultiple : selectedSKU.unitOfMeasureABVSingle;

    finalLeadsLableText4 = ` <div> ${leadQty4} ${uom} >  ${lblTBC} </div> `;
  }

  if (
    divLeadsIsVisible1 === false &&
    divLeadsIsVisible2 === false &&
    divLeadsIsVisible3 === false &&
    divLeadsIsVisible4 === false
  ) {
    // alert(`divLeadsIsVisible1 : ${divLeadsIsVisible1} : divLeadsIsVisible2 : ${divLeadsIsVisible2} : divLeadsIsVisible3 : ${divLeadsIsVisible3}`);

    return '';
  }

  let html = `

      <div id="divLeadTimes" class="ListingPageToggleDivLikeCustomasation">
        <div id="divLeadTimesHeader" style="display:block;cursor:pointer;">


        ${lblLeadTime}      <img alt=""  id="imgToggleLeadTimes"   width="20" height="20"  src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-toggle-up.svg"  style="width:20px;height:20px;" class="cartTopNewButton-Image-toggle-icon-rotated" >
        
        </div>
       <div id="divLeadTimesContent" class="ListingPageToggleDivLikeCustomasation-Content">
        ${finalLeadsLableText1}
        ${finalLeadsLableText2}
        ${finalLeadsLableText3}
        ${finalLeadsLableText4}

        </div>

      </div>
    `;

  return html;
}

function renderLeadTimeRow(
  listingModeIsLive,
  leadQty,
  leadDays,
  lblSameDay,
  lblDay,
  lblDays,
  lblTBC,
  unitOfMeasureABVSingle,
  unitOfMeasureABVMultiple
) {
  //assume values already validated

  //// calculate discounted price

  const finalQty = convertStringToInt(leadQty);
  const finalLeadDays = convertStringToInt(leadDays);

  // build the “> X days” part
  let after;
  if (finalLeadDays === null) {
    after = lblTBC;
  } else if (finalLeadDays < 1) {
    after = lblSameDay;
  } else if (finalLeadDays === 1) {
    after = `1 ${lblDay}`;
  } else {
    after = `${finalLeadDays} ${lblDays}`;
  }

  //// pick singular or multiple UOM
  const uomSingle = unitOfMeasureABVSingle;
  const uomMulti = unitOfMeasureABVMultiple;
  const uom = finalQty > 1 ? uomMulti : uomSingle;

  return ` <div> ${finalQty} ${uom} >  ${after} </div> `;
}

async function renderHTMLRightSectionBuyNowButton(
  listingModeIsLive,
  selectedSKU,
  lblBuyNow,
  lblContactSeller
) {
  return `

      <button id="buyNowbtn" class="ProductPageBuyNowBtn"> ${lblBuyNow} </button>

       <button id="btnContactSeller" @onclick="btnContactSeller_Click" class="ProductPageContactSellerBtn"> ${lblContactSeller} </button>
    
    `;
}

async function populateSelectedListing(selectedListingID) {
  console.log('✅ Populating Selected Listing Page');

  const storageKey = `Listing_${selectedListingID}_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedListing = loadFromLocalStorage(storageKey);
  if (cachedListing && Array.isArray(cachedListing) && cachedListing.length > 0) {
    console.log('✅ Loaded Listing from cache');

    // select the first category with the selectedSubcategoryID
    const selectedListing = cachedListing.find(s => s.listingID === selectedListingID);

    if (selectedListing) {
      console.log('✅ Loaded selected listing from cache');
      return selectedListing;
    } else {
      console.warn(`⚠️ No selected listing found with ID '${selectedListingID}' in cache`);

      // Fetch from the server if not cached
      console.log('🌐 Fetching Lising from server');
      return await fetchSelectedListing(selectedListingID);
    }
  }

  // Fetch from the server if not cached
  console.log('🌐 Fetching Listing from server');
  return await fetchSelectedListing(selectedListingID);
}

async function fetchSelectedListing(selectedListingID) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetListingDetailsForListingPageLiveAsync?listingID=${selectedListingID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch Listing from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(`🌐 Fetched Listing ${selectedListingID} from the server`);
      return selectedSubcategory;
    }
  } catch (error) {
    console.error('❌ Error fetching listing page listing:', error);
    return [];
  }
}

async function fetchSKUProductSpecAndOptionsLive(selectedSKUID) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetSKUProductSpecAndOptionsBySKUIDLiveAsync?tempSKUID=${selectedSKUID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch SKU from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(`🌐 Fetched SKU ${selectedSKUID} from the server`);
      return selectedSubcategory;
    }
  } catch (error) {
    console.error('❌ Error fetching SKUProductSpecAndOptions page listing:', error);
    return [];
  }
}

async function fetchBestGuessShippedFromCountryIDOnlyBySKUIDANDShipToCatalogSearchAsyncLive(
  selectedSKUID
) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/BestGuessShippedFromCountryIDOnlyBySKUIDANDShipToCatalogSearchAsync?tempSKUID=${selectedSKUID}&selectedCountryId=${appState.SiteShipToCountryIDCookie}&selectedStateId=${appState.SiteShipToStateIDCookie}&selectedCityId=${appState.SiteShipToCityIDCookie}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok)
        throw new Error('Failed to fetch BestGuessShippedFromCountryIDOnlyBySKUID from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(
        `🌐 Fetched BestGuessShippedFromCountryIDOnlyBySKUID SKU ${selectedSKUID} from the server`
      );
      return selectedSubcategory;
    }
  } catch (error) {
    console.error(
      '❌ Error fetching BestGuessShippedFromCountryIDOnlyBySKUID page listing:',
      error
    );
    return [];
  }
}

async function fetchBestGuessShippedFromCountryIDOnlyBySKUIDANDShipToCatalogSearchTempForPreviewAsyncLive(
  selectedSKUID
) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/BestGuessShippedFromCountryIDOnlyBySKUIDANDShipToCatalogSearchTempForPreviewAsync?tempSKUID=${selectedSKUID}&selectedCountryId=${appState.SiteShipToCountryIDCookie}&selectedStateId=${appState.SiteShipToStateIDCookie}&selectedCityId=${appState.SiteShipToCityIDCookie}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok)
        throw new Error('Failed to fetch BestGuessShippedFromCountryIDOnlyBySKUID from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(
        `🌐 Fetched Preview BestGuessShippedFromCountryIDOnlyBySKUID SKU ${selectedSKUID} from the server`
      );
      return selectedSubcategory;
    }
  } catch (error) {
    console.error(
      '❌ Error fetching Preview BestGuessShippedFromCountryIDOnlyBySKUID page listing:',
      error
    );
    return [];
  }
}

async function populateBestGuessSellerBuyingCompany(
  listingModeIsLive,
  selectedSKU,
  selectedListingStoreID
) {
  const bestGuessSKUDifferentSellerIDModel =
    listingModeIsLive === true
      ? await fetchBestGuessSellerBuyingCompanyIDAsyncLive(selectedSKU.skuid)
      : await fetchBestGuessSellerBuyingCompanyIDTempForPreviewAsync(selectedSKU.skuid);

  if (bestGuessSKUDifferentSellerIDModel.storeID === selectedListingStoreID) {
    return {
      buyingCompanyID: 0,
    };
  } else {
    //{"myString":"3"}

    const returnedBuyingCompanyID = bestGuessSKUDifferentSellerIDModel.myString;

    if (returnedBuyingCompanyID < 1) {
      return {
        buyingCompanyID: 0,
      };
    } else {
      const bestGuessSellerCompanyModel =
        listingModeIsLive === true
          ? await fetchGetBuyingCompanyDetailsByBuyingCompanyIDAsync(returnedBuyingCompanyID)
          : await fetchGetBuyingCompanyDetailsByBuyingCompanyIDAsync(returnedBuyingCompanyID);
    }
  }
}

async function fetchBestGuessSellerBuyingCompanyIDAsyncLive(selectedSKUID) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/BestGuessSellerBuyingCompanyIDAsync?tempSKUID=${selectedSKUID}&selectedCountryId=${appState.SiteShipToCountryIDCookie}&selectedStateId=${appState.SiteShipToStateIDCookie}&selectedCityId=${appState.SiteShipToCityIDCookie}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);

      if (!response.ok)
        throw new Error('Failed to fetch BestGuessSellerBuyingCompanyIDAsync from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(
        `🌐 Fetched  BestGuessSellerBuyingCompanyIDAsync SKU ${selectedSKUID} from the server`
      );
      return selectedSubcategory;
    }
  } catch (error) {
    console.error('❌ Error fetching BestGuessSellerBuyingCompanyIDAsync page listing:', error);
    return [];
  }
}

async function fetchBestGuessSellerBuyingCompanyIDTempForPreviewAsync(selectedSKUID) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/BestGuessSellerBuyingCompanyIDTempForPreviewAsync?tempSKUID=${selectedSKUID}&selectedCountryId=${appState.SiteShipToCountryIDCookie}&selectedStateId=${appState.SiteShipToStateIDCookie}&selectedCityId=${appState.SiteShipToCityIDCookie}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);

      if (!response.ok)
        throw new Error(
          'Failed to fetch BestGuessSellerBuyingCompanyIDTempForPreviewAsync from server'
        );

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(
        `🌐 Fetched  BestGuessSellerBuyingCompanyIDTempForPreviewAsync SKU ${selectedSKUID} from the server`
      );
      return selectedSubcategory;
    }
  } catch (error) {
    console.error(
      '❌ Error fetching BestGuessSellerBuyingCompanyIDTempForPreviewAsync page listing:',
      error
    );
    return [];
  }
}

async function fetchGetBuyingCompanyDetailsByBuyingCompanyIDAsync(possibleDifferentSellerID) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetBuyingCompanyDetailsByBuyingCompanyIDAsync?buyingCompanyID=${possibleDifferentSellerID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);

      if (!response.ok)
        throw new Error('Failed to fetch BestGuess BuyingCompany Details from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(
        `🌐 Fetched  BestGuess BuyingCompany Details possibleDifferentSellerID ${possibleDifferentSellerID} from the server`
      );
      return selectedSubcategory;
    }
  } catch (error) {
    console.error('❌ Error fetching BestGuess BuyingCompany Details page listing:', error);
    return [];
  }
}

async function fetchGetAllProductReviewsByListingIDAsync(selectedListingID) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetAllProductReviewsByListingIDAsync?listingID=${selectedListingID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);

      if (!response.ok)
        throw new Error('Failed to fetch GetAllProductReviewsByListingIDAsync from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(
        `🌐 Fetched  GetAllProductReviewsByListingIDAsync ${selectedListingID} from the server`
      );
      return selectedSubcategory;
    }
  } catch (error) {
    console.error('❌ Error fetching GetAllProductReviewsByListingIDAsync page listing:', error);
    return [];
  }
}

async function fetchGetAllSKUFAQBySKUIDLiveAsync(selectedSKUID) {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listing from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    // select the first category with the selectedListingID
      //    const selectedSubcategory = products.find(subcategory => subcategory.categoryID === selectedListingID);
      //    if (selectedSubcategory) {
      //        console.log("✅ Loaded selected category from pre-built data");
      //        return selectedSubcategory;
      //    } else {
      //        console.warn(`⚠️ No selected subcategory found with ID '${selectedListingID}' in pre-built data`);
      //        return [];
      //    }
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}
    } else {
      //const storageKey = `All_Subcategories_${lang}`; //"Subcategories_in_category_${selectedCategoryID}_${lang}"
      //const expiryKey = `${storageKey}_expiry`;
      //const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      //// Check cache first
      //const cached = loadFromLocalStorage(storageKey);
      //const expiryTime = loadFromLocalStorage(expiryKey);

      //if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      //    console.log("✅ Loaded All categories from cache");
      //    return cached;
      //}

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetAllSKUFAQBySKUIDLiveAsync?skuID=${selectedSKUID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch GetAllSKUFAQBySKUIDLiveAsync from server');

      const selectedSubcategory = await response.json();

      // // Save to localStorage
      // // Save the selected state with expiry (7 days by default)
      // saveToLocalStorageWithLimitAndExpiry(storageKey, selectedSubcategory, 30, expiryDuration, "categoryID");

      console.log(`🌐 Fetched  GetAllSKUFAQBySKUIDLiveAsync ${selectedSKUID} from the server`);
      return selectedSubcategory;
    }
  } catch (error) {
    console.error('❌ Error fetching GetAllSKUFAQBySKUIDLiveAsync page listing:', error);
    return [];
  }
}

async function fetchProductDetailsWithCategoryDetailsAndDepartmentDetailsByID(
  SelectedProductID,
  SelectedParentCategoryID,
  SelectedParentDepartmentID
) {
  try {
    if (isNodeEnvironment()) {
      return [];
      console.log(
        '🌐 Fetching All productDetailsWithCategoryDetailsAndDepartmentDetailsByID  from pre-built data'
      );
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[lang]) {
      //    const products = data[lang];
      //    console.log(`✅ Loaded All categories for language '${lang}' from pre-built data`);
      //    return products;
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${lang}'`);
      //    return [];
      //}
    } else {
      console.log(
        '🌐 Fetching All productDetailsWithCategoryDetailsAndDepartmentDetailsByID from server'
      );

      const storageKey = `Product_${SelectedProductID}_in_subcategories_${SelectedParentCategoryID}_category_${SelectedParentDepartmentID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(
          `✅ Loaded All productDetailsWithCategoryDetailsAndDepartmentDetailsByID for ${SelectedProductID} from cache`
        );
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetProductDetailsWithCategoryDetailsAndDepartmentDetailsByIDAsync?productID=${SelectedProductID}&categoryID=${SelectedParentCategoryID}&departmentID=${SelectedParentDepartmentID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(
          `Failed to fetch productDetailsWithCategoryDetailsAndDepartmentDetailsByID for ${SelectedProductID} from server`
        );

      const generalFinalResult = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, generalFinalResult);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(
        `🌐 Fetched All productDetailsWithCategoryDetailsAndDepartmentDetailsByID for ${SelectedProductID} from the server`
      );
      return generalFinalResult;
    }
  } catch (error) {
    console.error(
      '❌ Error fetching search product specific page productDetailsWithCategoryDetailsAndDepartmentDetailsByID',
      error
    );
    return [];
  }

  // _catalogDataService.GetProductDetailsWithCategoryDetailsAndDepartmentDetailsByIDAsync(SelectedProductID.ToString(), SelectedParentCategoryID.ToString(), SelectedParentDepartmentID.ToString(), _myUserIdentityInformationService.SiteLanguageCookie, _currentComponentCancellationTokenSource.Token);
}
